module.exports = __webpack_public_path__ + "img/11_2023_07_19.e02f6dee.jpg";